"use client";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { logger } from "@/lib/utils/logger";
import { AlertCircle } from "lucide-react";
import { useEffect } from "react";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function FeaturesError({ error, reset }: ErrorProps) {
  useEffect(() => {
    logger.error("Features page error", {
      error: error.message,
      digest: error.digest,
    });
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md p-4">
        <div className="flex flex-col items-center space-y-4 text-center">
          <AlertCircle className="h-12 w-12 text-destructive" />
          <div className="space-y-2">
            <h2 className="text-base font-semibold">Failed to Load Features</h2>
            <p className="text-sm text-muted-foreground">
              {error.message ||
                "An unexpected error occurred while loading this page."}
            </p>
          </div>
          <div className="flex gap-2">
            <Button onClick={reset} variant="default">
              Try Again
            </Button>
            <Button
              onClick={() => (window.location.href = "/")}
              variant="outline"
            >
              Go to Home
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
